import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import RecipeCard from './RecipeCard';

interface Recipe {
  id: string;
  title: string;
  instructions?: string;
  ingredients: string[];
}

interface RecipeListProps {
  recipes: Recipe[];
  searchQuery: string;
  onEdit: (recipe: Recipe) => void;
  onDelete: (recipe: Recipe) => void;
}

export const RecipeList: React.FC<RecipeListProps> = ({ recipes, searchQuery, onEdit, onDelete }) => {
  if (recipes.length === 0) {
    return (
      <Box sx={{ p: 4, textAlign: 'center', backgroundColor: 'background.paper', borderRadius: 2 }}>
        <Typography color="text.secondary" variant="body1">
          {searchQuery ? 'No recipes match your search query.' : 'No recipes yet. Click "Add Recipe" to create your first one!'}
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {recipes.map((recipe) => (
        <Grid item xs={12} sm={6} md={4} key={recipe.id}>
          <RecipeCard
            recipe={recipe}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default RecipeList;
